import {
  apiContainer,
  queryBuilder,
  massageSingleRecordBeforeUpsert
} from './apiContainer'
import { ArtificialDetailPropertyNames } from '../../common/globalNotary'
import uuid from 'react-uuid'

const SLICE_API_ROOT = '/services'

const serviceApi = apiContainer.injectEndpoints({
  endpoints: build => ({
    listServices: build.query({
      query: args => queryBuilder(SLICE_API_ROOT, args)
    }),
    listServiceTypes: build.query({
      query: () => `${SLICE_API_ROOT}/~/types`,
      // keepUnusedDataFor: 86400
    }),
    listServiceCategories: build.query({
      query: () => `${SLICE_API_ROOT}/~/categories`
    }),
    getOneFatService: build.query({
      async queryFn (_arg, _queryApi, _extraOptions, fetchWithBQ) {
        const primaryCall = fetchWithBQ(`${SLICE_API_ROOT}/${_arg.id}`)

        const contractCall = fetchWithBQ(`/contracts?service_id=${_arg.id}`)
        const assetCall = fetchWithBQ(`/assets?service_id=${_arg.id}`)

        const res = await Promise.all([primaryCall, contractCall, assetCall])
        const primaryData = res[0].data.data
        const contracts = res[1].data.data
        //alert(JSON.stringify(contracts))
        const assets = res[2].data.data

        primaryData[ArtificialDetailPropertyNames.DETACHED_DEPENDENCY1] = assets
        primaryData[
          ArtificialDetailPropertyNames.DETACHED_DEPENDENCY1_INITIAL_VALUES
        ] = assets

        primaryData[ArtificialDetailPropertyNames.DETACHED_DEPENDENCY2] =
          contracts

        primaryData[
          ArtificialDetailPropertyNames.DETACHED_DEPENDENCY2_INITIAL_VALUES
        ] = contracts

        // tmp fix for saving auxiliary updates
        return { data: { data: { ...primaryData, _objectId: uuid() } } }
      }
    }),
    bulkUpdateServices: build.mutation({
      query: args => {
        return {
          url: SLICE_API_ROOT,
          method: 'PATCH',
          body: { data: args }
        }
      }
    }),
    upsertService: build.mutation({
      query: args => {
        const { id } = args
        const actualArgs = massageSingleRecordBeforeUpsert(args)

        // console.log('before saving')
        // alert(JSON.stringify(actualArgs))
        // console.log('end before saving')

        if (id) {
          // update

          return {
            url: `${SLICE_API_ROOT}/${id}`,
            method: 'PUT',
            body: actualArgs
          }
        } //insert
        else {
          return {
            url: SLICE_API_ROOT,
            method: 'POST',
            body: actualArgs
          }
        }
      }
    }),
    deleteService: build.mutation({
      query: args => {
        return {
          url: `${SLICE_API_ROOT}/${args.id}`,
          method: 'DELETE'
        }
      }
    })
  }),
  overrideExisting: true
})

export const {
  useGetOneFatServiceQuery,
  useListServiceTypesQuery,
  useLazyListServicesQuery,
  useListServiceCategoriesQuery,
  useLazyListServiceCategoriesQuery,
  useLazyListServiceTypesQuery,
  useUpsertServiceMutation,
  useDeleteServiceMutation,
  useBulkUpdateServicesMutation
} = serviceApi
